import { MachinePolicyResource } from "../resources/index";
import BasicRepository from "./basicRepository";
import Client from "../client";
import {
    MachineResource,
    ResourceCollection,
} from "client/resources";

class MachinePolicyRepository extends BasicRepository<any, any> {
    constructor(client: Client) {
        super("MachinePolicies", client);
    }
    getMachines(machinePolicy: MachinePolicyResource): Promise<ResourceCollection<MachineResource>> {
        return this.client.get(machinePolicy.Links["Machines"]);
    }
}

export default MachinePolicyRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/machinePolicyRepository.ts